/**
 * Season year labels — the single source of truth for every user-visible
 * season string on the site.
 *
 * These existed hardcoded in about forty places and had drifted into three
 * different vintages at once (routeConfig said "2024-25" for NFL, the football
 * Learn pages said "2025", the basketball/hockey Learn pages said "2025-26").
 * Rolling the site to a new season is now editing this file, not a sitewide
 * grep.
 *
 * Football uses the single-year convention its own coverage does ("the 2026
 * season"); the winter sports that span a new year use the hyphenated form.
 */
export const SEASON_LABELS = {
  NFL: '2026',
  NCAAF: '2026',
  MLB: '2026',
  WNBA: '2026',
  NBA: '2026-27',
  NHL: '2026-27',
  MENSCBB: '2026-27',
};

export default SEASON_LABELS;
